import { useEffect, useState } from "react";
import { Box, Checkbox, CircularProgress, Typography } from "@mui/material";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import styles from "./S4_ShippingAddress.module.scss";
import { ButtonCust, ManageCard, SelectCust } from "../../../../widgets";
import Config from "../../../../../config/env.config.json";
import { ShippingComponentProps } from "./ShippingAddress";
import { AddShippingAddress } from "../AddShippingAddressDialog/AddShippingAddress";
import { getOneTimeShippingTaxCharges } from "../../../../../features/checkout/checkoutSlice";
import { useAppDispatch, useAppSelector } from "../../../../../app/hooks";
import { CardTypes } from "../../../../../enums";
import {
  getResolutionDetails,
  renderTextStyles,
} from "../../../../../utils/commonFunctions";
import { SimTypes } from "../../../../../features/checkout/Types";
import { gtmTagManager } from "../../../../../utils/commonFunctions/GtmTagManager";
import _ from "lodash";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";

const ShippingComponent = (props: ShippingComponentProps) => {
  const {
    shippingAddress,
    sendSimOptions,
    setShipPlan,
    shipPlan,
    updateAddress,
    content,
    handleBackBtn,
    taxAmount,
    setTaxAmount,
    setIsAddLinePayment,
    currentCard,
    confirmPurchaseHandler,
    pageName,
    formik,
    isBacknavigation,
    setIsBackNavigation,
    loader,
  } = props;

  const {
    title,
    title_1,
    subtitle,
    change_add,
    cnfrm_ship_add,
    continue_btn,
    change_card,
    select_ship_txt,
    num_mask,
    back_txt,
    review_title,
    review_subtitle,
    one_time_txt,
    shipping_txt,
    tax_txt,
    total_txt,
    pay_btn,
    shipping_logo,
  } = content;
  const [tick, setTick] = useState<any>(false);
  const [taxLoader, setTaxLoader] = useState<any>(false);
  const [isChangeAddress, setIsChangeAddress] = useState(false);
  const [showReviewDetails, setShowReviewDetails] = useState<boolean>(false);
  const [shippingAmount, setShippingAmount] = useState<number>(0);
  const [showCardChangeModal, setShowCardChangeModal] = useState(false);
  const dispatch = useAppDispatch();
  const { globalVal } = useAppSelector(
    (state: any) => state?.strapi?.globalValues || {}
  );
  const { getCCDetails } = useAppSelector((state: any) => state.account);
  const { mobile } = getResolutionDetails();

  const handleChangeSimOptions = (e: any) => {
    let event: any;
    const shippingData = sendSimOptions.find((el: any, index: number) => {
      event =
        index === 0
          ? globalVal?.gtmEvents?.shipping1Act
          : index === 1
          ? globalVal?.gtmEvents?.shipping2Act
          : globalVal?.gtmEvents?.shipping3Act;
      return el.value === e.target.value;
    });
    setTaxAmount(0);
    setShipPlan(shippingData);
    getShippingTaxAmount(shippingData);
    gtmTagManager({
      event: globalVal?.gtmEvents?.newNumEditPlan,
      click_section: "activation",
    });
  };

  useEffect(() => {
    setTaxAmount(0);
    // setShipPlan(shippingData);
    getShippingTaxAmount(shipPlan);
    gtmTagManager({
      event: globalVal?.gtmEvents?.newNumEditPlan,
      click_section: "activation",
    });
  }, [shipPlan]);

  const isOnlyEsimSelected = () => {
    let isOnlyEsimAdded = formik?.values?.every(
      (simItem: any) => simItem.simPreference === SimTypes.ESIM
    );
    return isOnlyEsimAdded;
  };
  const getShippingTaxAmount = (shippingData: any) => {
    if (shippingData?.shippingAmount > 0) {
      setShippingAmount(shippingData?.shippingAmount);
      setTaxLoader(true);
      dispatch(
        getOneTimeShippingTaxCharges({
          address: {
            ...shippingAddress,
          },
          amount: shippingData?.shippingAmount,
        })
      ).then((e: any) => {
        const res = e?.payload?.data;
        if (res?.status === "SUCCESS") {
          const taxAmount = res.data?.totalTax;
          setTaxAmount(taxAmount);
        }
        setTaxLoader(false);
      });
    }
  };

  const handleShippingDetails = () => {
    if (pageName === "activation") {
      confirmPurchaseHandler();
    } else if (pageName === "addline") {
      setIsAddLinePayment(true);
    }
    gtmTagManager({
      event: globalVal?.gtmEvents?.addALineReviewDetailsConfirm,
      click_section: "activation",
    });
  };

  useEffect(() => {
    if (isOnlyEsimSelected() && isBacknavigation) {
      handleBackBtn();
    }
  }, []);

  // useEffect(() => {
  //   if (!shipPlan) {
  //     const shippingData = sendSimOptions?.[0];
  //     setShipPlan(shippingData);
  //     getShippingTaxAmount(shippingData);
  //   } else {
  //     getShippingTaxAmount(shipPlan);
  //   }
  // }, [shippingAddress]);

  return (
    content &&
    (!showReviewDetails ? (
      <Box
        sx={{
          margin: { xs: "0px 0 150px", sm: "10px 0 100px" },
          width: { md: "100%" },
        }}
      >
        <KeyboardBackspaceIcon
          onClick={() => {
            if (isChangeAddress) {
              setIsChangeAddress(false);
            } else {
              handleBackBtn();
            }
          }}
          fontSize="large"
          sx={{
            display: { xs: "block", sm: "none" },
            position: "absolute",
            top: "21.5px",
            left: "20px",
            color: "var(--internal_back_arrow_color, var(--white))",
          }}
        />
        <Box
          className={styles.backCTA}
          onClick={() => {
            if (isChangeAddress) {
              setIsChangeAddress(false);
            } else {
              handleBackBtn();
            }
          }}
        >
          {!mobile && (
            <ArrowBackIosIcon
              sx={{
                ml: { md: "30px", sm: "25px", xs: "4%" },
                fontSize: "18px",
              }}
            />
          )}
          {!mobile && (
            <Box
              sx={{
                fontFamily: "var(--font_family_Medium)",
                fontWeight: "var(--font_weight_1)",
                fontSize: "18px",
                lineHeight: "30px",
              }}
            >
              {back_txt}
            </Box>
          )}
        </Box>
        {isChangeAddress ? (
          <AddShippingAddress
            content={content}
            updateAddress={(e: any) => {
              updateAddress(e);
              setIsChangeAddress(false);
            }}
            showBackArrow={false}
            showLabels={true}
          />
        ) : (
          <Box
            sx={{
              width: { xs: "90%", lg: "50%" },
              margin: { xs: "40px auto", sm: "20px auto" },
              background: "var(--white)",
              maxWidth: "570px",
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                borderBottom: "1px solid var(--lightgrey_6)",
                p: { xs: "15px 0", sm: "25px 0" },
              }}
            >
              {/* <Box
                component="img"
                alt={title_1}
                src={shipping_logo?.data?.attributes?.url || ""}
                mr="10px"
                className={styles.profile_img}
                width="51px"
                height="35px"
              ></Box> */}
              <Box
                sx={{
                  fontFamily: "var(--font_family_Bold)",
                  fontWeight: "var(--font_weight_4)",
                  fontSize: { xs: "18px", sm: "24px" },
                  lineHeight: "40px",
                  color: "var(--black)",
                }}
              >
                {pageName === "addline"
                  ? content?.res?.shipping_details
                    ? content?.res?.shipping_details
                    : title_1
                  : title}
              </Box>
            </Box>
            {pageName !== "addline" && (
              <Box className={styles.subtitle}>{subtitle}</Box>
            )}
            <Box className={styles.boxContainer}>
              <Box
                display="flex"
                justifyContent="space-between"
                className={styles.selectShipDetails}
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  width: "100%",
                }}
              >
                <Box
                  sx={{
                    width: { xs: "100%", sm: "70%", md: "100%" },
                  }}
                  className={styles.shipOptions}
                >
                  {/* <Box marginBottom={"5px"}>{select_ship_txt}</Box> */}
                  {/* <SelectCust
                    value={shipPlan?.value}
                    name="shipmentPlan"
                    width="100%"
                    // className={styles.selectCust}
                    options={sendSimOptions}
                    onChange={(e: any) => handleChangeSimOptions(e)}
                  /> */}
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      pl: "13px",
                      width: { xs: "95%", sm: "97%" },
                      border: "1px solid var(--text_field_border)",
                      borderRadius: "var(--text-field_border_radius)",
                      height: "55px",
                    }}
                  >
                    <Box
                      sx={{
                        fontSize: "13px !important",
                        fontFamily: "var(--font_family_Regular)",
                      }}
                    >
                      {shipPlan?.displayNameWeb}
                    </Box>
                  </Box>
                </Box>
              </Box>

              <Box
                className={styles.change_add}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  border: "1px solid var(--text_field_border)",
                  borderRadius: "var(--text-field_border_radius)",
                  p: "20px 0",
                  width: "100%",
                }}
              >
                <Box className={styles.shipping_text}>
                  <Checkbox
                    color="primary"
                    onChange={() => {
                      setTick(!tick);
                    }}
                    sx={{ color: "var(--primary_color)" }}
                    checked={tick}
                  />
                </Box>

                <Box
                  sx={{
                    display: { xs: "block", sm: "flex" },
                    flexDirection: "column",
                    alignItems: "flex-start",
                    padding: "0px 20px 10px 10px",
                  }}
                >
                  <Box
                    component={mobile ? "span" : "div"}
                    sx={renderTextStyles(4, "16px", "text_color", "28px")}
                  >
                    {cnfrm_ship_add}
                  </Box>
                  <Box
                    sx={_.merge(
                      renderTextStyles(4, "16px", "text_color", "28px"),
                      {
                        textDecoration: "underline",
                        paddingLeft: { xs: "5px", sm: "0px" },
                      }
                    )}
                    mb={0.5}
                    component={mobile ? "span" : "div"}
                    className={styles.address_text}
                  >
                    {shippingAddress?.address1}
                    {", "}
                    {shippingAddress?.city}
                    {", "}
                    {shippingAddress?.state}
                    {", "}
                    {shippingAddress?.zip}
                  </Box>
                </Box>
              </Box>
              <Box
                marginTop={"6px"}
                className={styles.changeCTA}
                onClick={() => {
                  if (!tick) {
                    setIsChangeAddress(true);
                    gtmTagManager({
                      event: globalVal?.gtmEvents?.changeShipAddChangeToPSIM,
                      click_section: "activation",
                    });
                  }
                }}
                sx={_.merge(
                  renderTextStyles(2, "14px", "primary_color", "29px"),
                  {
                    cursor: !tick ? "pointer" : "not-allowed",
                    opacity: !tick ? 1 : 0.5,
                  }
                )}
              >
                {change_add}
              </Box>
              {currentCard && shipPlan?.shippingAmount > 0 && (
                <Box className={styles.change_card}>
                  <Box display="flex" alignItems="center">
                    <Box
                      component={"img"}
                      src={
                        currentCard?.[0]?.type?.toUpperCase() ===
                        CardTypes?.VISA
                          ? content?.visa?.data?.attributes?.url
                          : currentCard?.[0]?.type?.toUpperCase() ===
                            CardTypes?.MASTERCARD
                          ? content?.master_card?.data?.attributes?.url
                          : currentCard?.[0]?.type?.toUpperCase() ===
                            CardTypes?.DISCOVER
                          ? content?.discover?.data?.attributes?.url
                          : currentCard?.[0]?.type?.toUpperCase() ===
                              CardTypes?.AMERICANEXPRESS ||
                            currentCard?.[0]?.type?.toUpperCase() ===
                              CardTypes?.AMEX
                          ? content?.american_ex?.data?.attributes?.url
                          : ""
                      }
                      alt={
                        currentCard?.[0]?.type?.toUpperCase() ===
                        CardTypes?.VISA
                          ? content?.visa?.data?.attributes?.alternativeText
                          : currentCard?.[0]?.type?.toUpperCase() ===
                            CardTypes?.MASTERCARD
                          ? content?.master_card?.data?.attributes
                              ?.alternativeText
                          : currentCard?.[0]?.type?.toUpperCase() ===
                            CardTypes?.DISCOVER
                          ? content?.discover?.data?.attributes?.alternativeText
                          : currentCard?.[0]?.type?.toUpperCase() ===
                            CardTypes?.AMEX
                          ? content?.american_ex?.data?.attributes
                              ?.alternativeText
                          : ""
                      }
                      style={{ width: "45px", height: "30px" }}
                    />
                    <Typography
                      pl="10px"
                      fontFamily="var(--font_family_Semibold)"
                      fontSize="14px"
                    >
                      {num_mask}
                      {currentCard?.[0]?.ccNumberMask}
                    </Typography>
                  </Box>
                  <Typography
                    className={styles.changeCTA}
                    onClick={() => {
                      setShowCardChangeModal(true);
                      gtmTagManager({
                        event: globalVal?.gtmEvents?.changeCardChangeToPSIM,
                        click_section: "activation",
                      });
                    }}
                  >
                    {change_card}
                  </Typography>
                </Box>
              )}
            </Box>
            <Box
              sx={{
                textAlign: "center",
                pb: "25px",
              }}
            >
              <ButtonCust
                sx={{
                  height: "45px !important",
                  // "&:hover": {
                  //   backgroundColor: "var(--button_hover_color) !important",
                  //   border: "1px solid var(--button_hover_color) !important",
                  // },
                  width: "250px",
                }}
                variantType={Config.PRIMARY_BUTTON_TYPE}
                onClick={!loader ? handleShippingDetails : () => {}}
                disabled={!tick || taxLoader}
                loading={pageName === "activation" && props.btnLoader}
              >
                {loader ? <CircularProgress /> : continue_btn}
              </ButtonCust>
            </Box>
            <ManageCard
              cardData={getCCDetails}
              showCardChangeModal={showCardChangeModal}
              setShowCardChangeModal={setShowCardChangeModal}
              isModalRequired={true}
              pageName={"activation"}
              isDescription={true}
              payType={true}
            />
          </Box>
        )}
      </Box>
    ) : (
      <Box
        className={styles.reviewDetails}
        sx={{
          margin: { xs: "10px 0 150px", sm: "30px 0 170px" },
          width: { md: "100%" },
        }}
      >
        <Box
          className={styles.backCTA}
          onClick={() => setShowReviewDetails(false)}
        >
          <ArrowBackIosIcon sx={{ ml: { md: "30px", sm: "25px", xs: "4%" } }} />
          {!mobile && (
            <Box
              sx={{
                textDecoration: "underline",
                fontFamily: "var(--font_family_Bold)",
              }}
            >
              {back_txt}
            </Box>
          )}
        </Box>
        <Box className={styles.pageTitle}>{review_title}</Box>
        <Box className={styles.subtitle}>{review_subtitle}</Box>
        <Box className={styles.reviewBoxContainer}>
          <Box className={styles.container}>
            <Box className={styles.oneTimeTxt}>{one_time_txt}</Box>
            <Box className={styles.charges}>
              <Box className={styles.charge}>
                <Box>{shipping_txt}</Box>
                <Box>${shippingAmount?.toFixed(2)}</Box>
              </Box>
              <Box className={styles.charge}>
                <Box>{tax_txt}</Box>
                <Box>${taxAmount?.toFixed(2)}</Box>
              </Box>
              <Box className={styles.charge}>
                <Box fontWeight={`var(--font_weight_2)`}>{total_txt}</Box>
                <Box fontWeight={`var(--font_weight_2)`}>
                  ${(shippingAmount + taxAmount)?.toFixed(2)}
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
        <Box
          sx={{
            textAlign: "center",
          }}
        >
          <ButtonCust
            sx={{ marginTop: "30px" }}
            variantType={Config.PRIMARY_BUTTON_TYPE}
            onClick={!loader ? handleShippingDetails : () => {}}
            loading={pageName === "activation" && props.btnLoader}
          >
            {loader ? <CircularProgress /> : pay_btn}
          </ButtonCust>
        </Box>
      </Box>
    ))
  );
};

export default ShippingComponent;
